import { render, staticRenderFns } from "./CmgPasswordResetRequestForm.vue?vue&type=template&id=579a50c4&scoped=true&lang=pug"
import script from "./cmg-password-reset-request-form.ts?vue&type=script&lang=ts&external"
export * from "./cmg-password-reset-request-form.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPasswordResetRequestForm.vue?vue&type=style&index=0&id=579a50c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a50c4",
  null
  
)

export default component.exports